import Header from "../../Header/Header";
import Footer from "../../Footer/Footer";
import "./HealthChecks_js.js";
import "./HealthChecks_css.css";
import ServiceShowcase from "../ServiceShowCase.jsx";
import CardSlider from "../CardSlider.jsx";
import banner from "../../Assets/cover.png";
import rightfitimg from "../../Assets/right-fit-img.png"
import ServicesGrid from "../ServiceGrid.jsx";
import CardsContainer from "../CardsContainer.jsx";
import Testimonials, { testimonialsData } from "../../Testimonial/Testimonial.jsx";
import CoverHero from "../CoverHero.jsx";
import { useState } from "react";
import LoginModal from "../../Modals/LoginModal.js";
import {
  serviceShowcaseData,
  healthCheck_data,
  operateheading,
  operateservices,
  wellbeingheading,
  wellbeingservices,
  optservices,
  optheading,
  stepping_out_data,
  rightFitData,
  testimonialData,
  settings
} from "./HealthChecks_js.js";
import { useNavigate } from "react-router-dom";

const HealthChecks = () => {
 const navigate = useNavigate();
 
  return (
    <>
      <Header />
      <CoverHero image={banner} title="Health Checks" />
      <div className="servicesShowCase">
        {serviceShowcaseData.map((service, index) => (
          <ServiceShowcase
            key={index}
            className="medical-equ"
            data={service}
            onServiceClick={() => navigate('/')}
          />
        ))}
      </div>
      
      <div className="choose-excellence grey-bg mt-40px">
        <div className="excellence-content">
          <div className="blend-container">
            <h2 className="excellence-title second-title">
              {healthCheck_data.title}
            </h2>
            <p>{healthCheck_data.para1}</p>
            <p>{healthCheck_data.para2}</p>
          </div>

          <div className="image-container">
            <img src={healthCheck_data.image} alt={healthCheck_data.title} />
          </div>
        </div>
      </div>

      <CardSlider
        className="white-bg"
        heading={operateheading}
        data={operateservices}
      />

      <CardsContainer
        heading={wellbeingheading}
        services={Object.values(wellbeingservices)}
      />
      <CardsContainer
        heading={optheading}
        services={Object.values(optservices)}
        className="white-bg"
      />
      <div className="choose-excellence grey-bg mt-40px">
        <div className="excellence-content">
          <div className="blend-container">
            <h2 className="excellence-title second-title fs-46">
              {stepping_out_data.title}
            </h2>
            <p>{stepping_out_data.para1}</p>
          </div>

          <div className="image-container">
            <img src={stepping_out_data.image} alt={stepping_out_data.title} />
          </div>
        </div>
      </div>

      <div className="premier-option">
        <div className="premier-option-content">
          <div className="premier-option-text">
            <h2>{rightFitData.heading}</h2>
            <ul>
              {rightFitData.list.map((item, index) => (
                <li key={index} className="list-row ">
                  <span className="check-icon">
                    {item.icon}
                  </span>
                  {item.text}
                </li>
              ))}
            </ul>

          </div>
          <div className="premier-option-image">
            <img src={rightfitimg} alt="Premier Option" />
          </div>
        </div>
      </div>
      <div className="impact">
        <Testimonials
          data={testimonialData}
          textKey="desc"
          imgKey="userimg"
          nameKey="username"
          settings={settings}
          className="radiology-testimonials"
        />
      </div>
      <ServicesGrid className="bg-white" title="Check Our Other Services" exclude="Health Checks" />
      <Footer />
    </>
  );
};

export default HealthChecks;
